export const DOWNLOAD_UPSELL_STEPS = {
  READY: 'ready',
  DISCOUNT: 'discount',
  SINGLE: 'single',
  EXIT: 'exit',
  SUCCESS: 'success',
  SUCCESS_DISCOUNT: 'success_discount',
  SUCCESS_SINGLE: 'success_single',
  SUCCESS_PLAN: 'success_plan',
}

export const PLAN_FEATURED = {
  name: 'Pro',
  artsPerMonth: 70,
}

export {
  EXIT_FEEDBACK_OPTIONS,
  PLAN_OPTIONS,
} from '../UpsellFlows/sharedConstants'

export const PACKAGE_OPTIONS = [
  { id: '25', label: '25 artes', price: 'R$ 119' },
  { id: '50', label: '50 artes', price: 'R$ 249' },
  { id: '100', label: '100 artes', price: 'R$ 499' },
]
